<template>
    <div v-if="!loading" class="mid">
        <b-link class="back" @click="leave"><svg-icon icon="back" /></b-link>
        <h1>{{ title }}</h1>
        <div class="agreement">
            <div class="agreement__box">
                <p>{{ $t($store.state.site.id + '-agree')}}</p>
            </div>
            <b-button class="p-3 mt-3" block variant="primary" @click="$emit('proceed', $store.getters.getSecureAssessment ? 'permissions' : 'intro')">{{ $t('agree') }}</b-button>
        </div>
    </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon';


export default {
  components: { SvgIcon },
    name: "AssessmentAgreement",
    props: {
        title: String,
        loading: Boolean
    },
    methods: {
        leave(){
            this.$router.push('/assessments');
        }
    }
}

</script>